import React, { createContext, useReducer } from 'react';
import AppReducer from './AppReducer'

const initialState = {
    shipmeents: [
        { ShipmentNumber: null, TransportMode: null, Status: null, UpdateDate: null }
    ],
    embarqueSummary: [],
    shipmentResults: { request: true, data: [] },
    results: false,
    resultList: [],
    filterSearch: null,
    eventList: {},
    openReserva: true,
    openOrigen: true,
    openDestino: true
}

export const GlobalContext = createContext(initialState);
export const GlobalProvider = ({ children }) => {
    const [state, dispatch] = useReducer(AppReducer, initialState);

    function SearchParam(data) {
        dispatch({
            type: 'SET_SEARCH_VALUE',
            payload: data
        });
    };

    function getTrack(trackId) {
        dispatch({
            type: 'SET_SHIPMENT',
            payload: trackId
        });
    };

    function Results(data) {
        dispatch({
            type: 'SET_RESULTS',
            payload: data
        });
    };

    function ResultsList(data) {
        dispatch({
            type: 'SET_RESULTS_LIST',
            payload: data
        });
    };

    function SetEventList(data) {
        dispatch({
            type: 'SET_EVENT_LIST',
            payload: data
        });
    };

    function DespliegueDescarga(data) {
        dispatch({
            type: 'SET_DOWNLOAD_ESTATUS',
            payload: data
        });
    };


    return (<GlobalContext.Provider value={{
        shipmeents: state.shipmeents,
        embarqueSummary: state.embarqueSummary,
        shipmentResults: state.shipmentResults,
        results: state.results,
        resultList: state.resultList,
        filterSearch: state.filterSearch,
        eventList: state.eventList,
        openReserva: state.openReserva,
        openOrigen: state.openOrigen,
        openDestino: state.openDestino,
        getTrack,
        Results,
        ResultsList,
        SearchParam,
        DespliegueDescarga
    }}>
        {children}
    </GlobalContext.Provider>);
}